import { render, staticRenderFns } from "./table-multi-lotto.vue?vue&type=template&id=60341eb3"
import script from "./table-multi-lotto.vue?vue&type=script&lang=js"
export * from "./table-multi-lotto.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports